<div class="bc-modal confirmation-container" [attr.data-automation-id]="'bc-confirm-modal'">
  <div class="modal-content modal-dialog confirmation-content">
    <div class="modal-header">
      <div class="modal-title gc-text-bold">{{ config.title | translate }}</div>
      <div class="subtitle" *ngIf="!!config.subtitle">{{ config.subtitle | translate }}</div>
    </div>
    <div class="modal-body">
      <button #confirmButton class="btn btn-dark js-confirm-button"
              type="button"
              (click)="onConfirm()"
              [attr.data-automation-id]="'bc-confirm-button'">
        <span>{{ config.buttonTitle | translate }}</span>
      </button>
    </div>
    <div class="modal-footer">
      <div class="end-not-show-again" *ngIf="!!config.secondaryActionTitle">
        <button type="button" (click)="onSecondaryAction()" [attr.data-automation-id]="'bc-end-not-show-again-button'">
          <span [attr.data-automation-id]="'bc-end-not-show-again-text'">{{ config.secondaryActionTitle | translate }}</span>
        </button>
      </div>
      <div class="continue"
           *ngIf="!!config.cancelTitle">
        <button type="button" (click)="onCancel()" [attr.data-automation-id]="'bc-end-continue-button'">
          <span [attr.data-automation-id]="'bc-end-continue-text'">{{ config.cancelTitle | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
